module.exports = __webpack_public_path__ + "static/media/Products 1.909ad740.svg";